var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 45,
    viewBox: "0 0 37 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 18.7197C36 32.3308 18.5 43.9975 18.5 43.9975C18.5 43.9975 1 32.3308 1 18.7197C1 14.0784 2.84374 9.62724 6.12563 6.34536C9.40752 3.06347 13.8587 1.21973 18.5 1.21973C23.1413 1.21973 27.5925 3.06347 30.8744 6.34536C34.1563 9.62724 36 14.0784 36 18.7197Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 24.5531C21.7217 24.5531 24.3333 21.9414 24.3333 18.7197C24.3333 15.4981 21.7217 12.8864 18.5 12.8864C15.2783 12.8864 12.6667 15.4981 12.6667 18.7197C12.6667 21.9414 15.2783 24.5531 18.5 24.5531Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSymbol);
export default __webpack_public_path__ + "static/media/LocationSymbol.3d63984fd689ff5369b1c1f0eba7ba13.svg";
export { ForwardRef as ReactComponent };